export type StepKey = "fetcher" | "unifier" | "advisor";

// By Interface > {Step} > Create new family > Create / Cancel
export const CREATE_FAMILY_SUBMIT_TRACKER: Record<StepKey, string> = {
  fetcher: "993",
  unifier: "995",
  advisor: "997",
};
export const CREATE_FAMILY_CANCEL_TRACKER: Record<StepKey, string> = {
  fetcher: "994",
  unifier: "996",
  advisor: "998",
};

// By Interface > {Step} > Edit/Duplicate family > Detach / Attach / Save / Cancel
// Shared by EditFamilyModal (Edit) and FamilyDrawer in duplicate mode — both
// use the same tracker ids for these actions.
export const EDIT_FAMILY_DETACH_TRACKER: Record<StepKey, string> = {
  fetcher: "999",
  unifier: "1003",
  advisor: "1007",
};
export const EDIT_FAMILY_ATTACH_TRACKER: Record<StepKey, string> = {
  fetcher: "1000",
  unifier: "1004",
  advisor: "1008",
};
export const EDIT_FAMILY_SAVE_TRACKER: Record<StepKey, string> = {
  fetcher: "1001",
  unifier: "1005",
  advisor: "1009",
};
export const EDIT_FAMILY_CANCEL_TRACKER: Record<StepKey, string> = {
  fetcher: "1002",
  unifier: "1006",
  advisor: "1010",
};
